import i18n from '../locales/index'
const isChaibao = false

export default {
  isChaibao,
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: i18n.t('config_index_40', ['珹宝']),
  /**
   * @description logo图标
   */
  logo: require('@/assets/images/logo.png'),
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 7,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  // baseUrl: {
  //   dev: 'http://127.0.0.1:3000/fresh',
  //   pro: 'https://staging.chengbao88.com/fresh'
  // },

  wsUrl: {
    dev: 'ws://127.0.0.1:3000/wss/machine',
    pro: 'wss://api.17cc.cn/wss/machine'
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'shops-shops'
}
